export default __webpack_public_path__ + "static/media/cigar2.53d3a88f.jpg";